import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboNumeroPedido`, method: 'GET', body: null, token: token})
}